<template>
	<div class="notfound-container d-flex flex-column h-100">
		<header class="masthead">
			<nav class="navbar navbar-expand-lg ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="flex-shrink-0  m-auto container">
			<div class="row align-items-center">
				<div class="col-md-6 text-white">
					<h2 class="">Oops, the page you were Looking for doesn’t exist.</h2>
					<p>
						You may have mistyped the address, or the page may have been moved.
					</p>
					<a href="/#/" class="btn btn-light btn-lg"
						>Go to Homepage <i class="fa fa-angle-right ml-2"></i
					></a>
				</div>
				<div class="col-md-6">
					<img src="../../assets/img/page404.png" alt="" class="img-fluid" />
				</div>
			</div>
		</section>
	</div>
</template>

<style></style>

<script>
export default {
	name: "PageNotFound2",
	components: {},
	computed: {},
	created() {
		   this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultnav", false);
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("setLoader", false);
	},
	mounted() {
		window.scroll(0, 0);
	},

	methods: {
		gotoSingin() {
			this.$router.push("/login");
		},
	},

	data() {
		return {};
	},
};
</script>
